var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctValue, FctValue18, FctValueListN } from '../../../../Fct/generics/FctParams';
import { supportedPools } from '../helpers/supportedContracts';
export var CalculateTokenAmount = createPlugin({
    protocol: 'CURVE',
    type: 'GETTER',
    method: 'calc_token_amount',
    description: 'Estimate the amount of LP tokens minted or burned based on a deposit or withdrawal.',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_pool',
                    options: supportedPools.filter(function (pool) { return pool.chainId === Number(chainId); }),
                }),
                amount1: new FctValue({}),
                amount2: new FctValue({}),
                amount3: new FctValue({}),
                amount4: new FctValue({}),
                methodParams: {
                    amounts: new FctValueListN({}),
                    isDeposit: new FctBoolean({}),
                },
            },
            output: { expectedAmount: new FctValue18({ innerIndex: 0, destination: 'wei_amount' }) },
        });
    },
    initParams: {
        methodParams: {
            isDeposit: 'false',
        }
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input;
        var to = input.to, methodParams = input.methodParams;
        var getParams = function () { return __awaiter(void 0, void 0, void 0, function () {
            var defaultReturn, pool, i, label;
            return __generator(this, function (_a) {
                defaultReturn = {
                    amount1: undefined,
                    amount2: undefined,
                    amount3: undefined,
                    amount4: undefined,
                    methodParams: {
                        amounts: undefined,
                    },
                };
                if (!to.value || typeof to.value !== 'string') {
                    return [2 /*return*/, {
                            params: defaultReturn,
                            error: undefined,
                        }];
                }
                pool = to.options.find(function (p) { return p.address === to.value; });
                if (!pool)
                    return [2 /*return*/, {
                            params: defaultReturn,
                            error: undefined,
                        }];
                methodParams.amounts.value = [];
                pool.coins.forEach(function (coin, index) {
                    var label = "amount".concat(index + 1);
                    if (!input[label])
                        return;
                    input[label].decimals = Number(coin.decimals);
                    input[label].label = coin.symbol;
                    if (!methodParams.amounts.value)
                        return;
                    input[label].hidden = false;
                    input[label].readonly = false;
                    input[label].required = true;
                    if (input[label].value && typeof input[label].value === 'string') {
                        methodParams.amounts.value.push(input[label].value);
                    }
                });
                for (i = 1; i < 5; i++) {
                    if (i <= pool.coins.length)
                        continue;
                    label = "amount".concat(i);
                    if (!input[label])
                        continue;
                    input[label].hidden = true;
                    input[label].readonly = true;
                    input[label].required = false;
                    input[label].decimals = 0;
                }
                return [2 /*return*/, {
                        params: {
                            methodParams: {
                                amounts: methodParams.amounts.value,
                            },
                        },
                        error: undefined,
                    }];
            });
        }); };
        return { get: getParams, depParamKeys: ['to', 'amount1', 'amount2', 'amount3', 'amount4'] };
    },
    getSubscribtions: function (_a) { return [
        {
            callback: function (params) {
                if (!params)
                    return;
                var input = params;
                var setAmount = function (amountNumber) {
                    var amountsValue = input.methodParams.amounts.value || [];
                    var amountLabel = "amount".concat(amountNumber);
                    var inputAmount = input[amountLabel];
                    var amountIndex = Number(amountNumber) - 1;
                    if (inputAmount.hidden) {
                        var amounts = amountsValue.slice(0, amountIndex);
                        input.methodParams.amounts.setQuiet({ value: amounts });
                        return;
                    }
                    amountsValue[amountIndex] = inputAmount.value || '0';
                    input.methodParams.amounts.setQuiet({ value: amountsValue });
                };
                setAmount('1');
                setAmount('2');
                setAmount('3');
                setAmount('4');
                return;
            },
            id: 'set_amounts_array',
        },
    ]; },
    // onCreate: ({ input }) => {
    //   const setAmount = (amountNumber: "1" | "2" | "3" | "4") => {
    //     const amountsValue = input.methodParams.amounts.value || []
    //     const amountLabel = `amount${amountNumber}` as const
    //     const inputAmount = input[amountLabel]
    //     const amountIndex = Number(amountNumber) - 1
    //     if (inputAmount.hidden) {
    //       const amounts = amountsValue.slice(0, amountIndex)
    //       input.methodParams.amounts.set({ value: amounts })
    //       return
    //     }
    //     amountsValue[amountIndex] = inputAmount.value || '0'
    //     input.methodParams.amounts.set({ value: amountsValue })
    //   }
    //   input.amount1.subscribe({
    //     callback: () => {
    //       setAmount('1')
    //     },
    //     id: 'set amount1',
    //   })
    //   input.amount2.subscribe({
    //     callback: () => {
    //       setAmount('2')
    //     },
    //     id: 'set amount2',
    //   })
    //   input.amount3.subscribe({
    //     callback: () => {
    //       setAmount('3')
    //     },
    //     id: 'set amount3',
    //   })
    //   input.amount4.subscribe({
    //     callback: () => {
    //       setAmount('4')
    //     },
    //     id: 'set amount4',
    //   })
    //   setAmount('1')
    //   setAmount('2')
    //   setAmount('3')
    //   setAmount('4')
    // },
});
